import { render, staticRenderFns } from "./ViewAttachments.vue?vue&type=template&id=de55ec52&scoped=true&"
import script from "./ViewAttachments.vue?vue&type=script&lang=js&"
export * from "./ViewAttachments.vue?vue&type=script&lang=js&"
import style0 from "./ViewAttachments.vue?vue&type=style&index=0&id=de55ec52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de55ec52",
  null
  
)

export default component.exports